module.exports = __webpack_public_path__ + "static/media/ImgNovedades221014_1.3903cc2d.jpg";